export class GetDataCatalogNamespaceResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "DataCatalogNamespace",
            "format": ""
        },
        {
            "name": "joinability",
            "baseName": "joinability",
            "type": "Array<DataCatalogJoinabilityEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogNamespaceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
